import React from 'react';
import { useForm } from "react-hook-form";
import { Col, Row } from 'react-bootstrap';

const AddCar = () => {
     const { register, handleSubmit } = useForm();
     const onSubmit = data => {
          console.log(data)


          const url = `https://secure-springs-71035.herokuapp.com/service`;

          fetch(url, {
               method: 'POST',
               headers: {
                    'content-type': 'application/json'
               },
               body: JSON.stringify(data)
          })
               .then(res => res.json())
               .then(data => console.log(data))

     };


     return (
          <div className='my-5 container'>
               <h2 className='text-center pb-4 fw-bold text-primary'> ADD THE CARD OF YOUR CHOICE </h2>
               <Row>
                    <Col sm={6}>
                         <div className='mx-auto w-100 '>
                              <form className='d-flex flex-column' onSubmit={handleSubmit(onSubmit)}>
                                   <input className='mb-2 ' placeholder='Name' {...register("name", { required: true, maxLength: 20 })} />
                                   <input className='mb-2 ' placeholder='Suppliers Name' {...register("supplierName", { required: true, maxLength: 20 })} />
                                   <textarea className='mb-2 p-4' placeholder='Description' {...register("description")} />
                                   <input className='mb-2' placeholder='Price' type="number" {...register("price")} />
                                   <input className='mb-2' placeholder='Quantiry' type="number" {...register("quantity")} />
                                   <input className='mb-2' placeholder='Phot URL' type="text" {...register("img")} />
                                   <input type="submit" value="Add car" />
                              </form>
                         </div>

                    </Col>
                    <Col sm={6}>
                         <img className='img-fluid w-100 h-100' src="https://images.unsplash.com/flagged/photo-1573162915835-520ee6d112b5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80" alt="" />
                    </Col>
               </Row>


          </div>
     );
};

export default AddCar;